<div class="my-requests-container">
  <div class="header-section">
    <h3 data-test="MyRequestsTitle">My Requests</h3>
    <div class="action-group">
      <div class="refresh-btn">
        <button mat-mini-fab [disabled]="disableReload$ | async" (click)="reloadRequests()">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
      <div class="new-request-btn">
        <button mat-raised-button color="primary" data-test="NewRequestButton" (click)="openNewRequestModal()">
          New Request
        </button>
      </div>
    </div>
  </div>

  <div class="content-section bg-white">
    <ng-container *ngIf="(vm$ | async) as vm; else loadingTemplate">
      <div class="table-container">
        <table mat-table
            matSort
            [matSortActive]="DEFAULT_SORT_OPTION.active"
            [matSortDirection]="DEFAULT_SORT_OPTION.direction"
            (matSortChange)="handleSortEvent($event)"
            [dataSource]="vm.paginatedRequests">

          <ng-container matColumnDef="requestId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-request-id">Request ID</th>
            <td mat-cell *matCellDef="let row">
              @if (row.status === 'Building') {
                {{ row.requestId }}
              } @else {
                <a [routerLink]="RouteManager.requestPathFormat(row.requestId)">{{ row.requestId }}</a>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="vcc">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-vcc">VCC</th>
            <td mat-cell *matCellDef="let row">{{ row.vcc }}</td>
          </ng-container>

          <ng-container matColumnDef="supplierName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-supplier">Supplier</th>
            <td mat-cell *matCellDef="let row">{{ row.supplierName }}</td>
          </ng-container>

          <ng-container matColumnDef="contractNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-contract-number">Contract Number</th>
            <td mat-cell *matCellDef="let row">{{ row.contractNumber }}</td>
          </ng-container>

          <ng-container matColumnDef="lastModifiedDateUtc">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-date-update">Date Updated</th>
            <td mat-cell 
                *matCellDef="let row"
                [matTooltip]="row.lastModifiedDateUtc | date: 'long'"
                matTooltipPosition="before"> 
              {{ row.lastModifiedDateUtc | date:'MMMM d, yyyy' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-status">Status</th>
            <td mat-cell *matCellDef="let row">{{ row.status }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="requestColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: requestColumns"></tr>

          <tr *matNoDataRow>
            <td [attr.colspan]="requestColumns.length">
              @if(fetchingRequest$ | async) {
                <ng-container *ngTemplateOutlet="loadingTemplate"/>
              } @else {
                No requests made by user
              }
            </td>
          </tr>
        </table>
      </div>

      <div class="paginator-container">
        <mat-paginator
          [pageSizeOptions]="pageSizeOptions"
          [length]="vm.requests.length"
          [pageSize]="vm.pageEvent.pageSize"
          [pageIndex]="vm.pageEvent.pageIndex"
          (page)="handlePageEvent($event)"
          showFirstLastButtons
        />
      </div>
    </ng-container>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="loading-spinner"><mat-spinner [diameter]="100"></mat-spinner></div>
</ng-template>
